import fetch from '../config/fetch'
import { getStore, formatTime, getObjectInCache, setStore } from '../config/mUtils'

export const getDataCache = async (url, data = {}, isCache = false) => {
    let path = url.replace(/[\W_]+/g, "_");
    if (!!data && Object.keys(data).length > 0){
        Object.keys(data).forEach(key => {
            path += + '_' + key + '_' + data[key];
        })
    }
    
    if (!!isCache){
        let obj = getObjectInCache(path);
        if (!!obj){
            return new Promise((resolve) => {
                resolve(obj);
            });
        }
    }

    let result = await getData(url, data);
    setStore(path, result);
    return new Promise((resolve) => {
        resolve(result);
    });
}

export const getData = (url, data = {}, isAuthorization = true) => {

    let token = '';
    if (isAuthorization) {
        token = getStore('auth_token')
    }
    return fetch(url, data, 'GET', 'fetch', token);
}

export const getFileData = (url, data = {}, isAuthorization = true) => {

    let token = '';
    if (isAuthorization) {
        token = getStore('auth_token')
    }
    return fetch(url, data, 'GET', 'fetch', token, true);
}

export const postData = (url, data = {}, isAuthorization = true) => {

    let token = '';
    if (isAuthorization) {
        token = getStore('auth_token')
    }
    return fetch(url, data, 'POST', 'fetch', token);
}

export const getPromise = (url, data = {}, isAuthorization = true) =>{
    let token = '';
    if (isAuthorization) {
        token = getStore('auth_token')
    }
    return fetch(url, data, 'GET', '', token);
}

export const srcDaysOfWeek = () => {
    let daysOfWeek = [
        { value: 1, label: "周一", disabled: false },
        { value: 2, label: "周二", disabled: false },
        { value: 3, label: "周三", disabled: false },
        { value: 4, label: "周四", disabled: false },
        { value: 5, label: "周五", disabled: false },
        { value: 6, label: "周六", disabled: false },
        { value: 7, label: "周日", disabled: false }
    ];
    return daysOfWeek;
}

export const srcTimesOfDay = (isSameAbove = true) => {
    let src = [];
    let startTime = 8;
    let endTime = 23;
    let count = endTime - startTime;
    if (count < 0) {
        count = 0;
    }
    if (isSameAbove) {
        src.push({
            value: 0,
            label: "与上述一致",
            disabled: true
        });
    }
    for (let i = 0; i <= count * 2; i++) {
        let item = {};
        let hour = startTime + Math.floor(i / 2);
        let mintue = 0;
        if (i % 2 == 1) {
            mintue = 30;
        }
        item.label = formatTime(hour, mintue);
        item.value = hour * 60 + mintue;
        item.disabled = false;
        src.push(item);
    }

    return src;
}

export const getPhoneTypeList = () => {
    let list = [
        { value: 1, label: "北美手机号"},
        { value: 2, label: "中国手机号" },
    ];
    return list;
}

export const convertPageModel = (model) => {

    let sortField = '';
    if (!!model.sortField){
        sortField = model.sortField;
    }
    let isDesc = false;
    if (model.isDesc){
        isDesc = true;
    }
    let keyWord = '';
    if (!!model.keyWord){
        keyWord = model.keyWord;
    }
    //console.log(model);

    let data = {
        PageNumber:model.pageNumber,
        PageSize:model.pageSize,
        SortField:sortField,
        IsDesc:isDesc,
        KeyWord: keyWord,
        StartDateText:model.startDate,
        EndDateText:model.endDate,
        FilterList: null
    };
    if (!!model.filterList){
        data.FilterList = model.filterList;
    }
    if (!!model.additionalFilter){
        data.AdditionalFilter = model.additionalFilter;
    }
    return data;
}

export const convertToUTCDate = (date) => {
    if (!!date && date instanceof Date){
        return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0))
    } 
    return date;
}


// WEBPACK FOOTER //
// ./src/service/api-base.service.js